import React, {FC, useCallback, useEffect, useState} from 'react';

import {sendMobileAnalyticsPerSession} from '@optimaxdev/analytics/desktop/lib/sendAnalyticsEvent/index';

import {TYP_RATE_US} from 'constants/analytics/events/typ';
import {REVIEWS_POPUPS} from 'constants/popupNames';
import {useAdditionalPopups} from 'desktop/hooks/useAdditionalPopups/useAdditionalPopups';

import {DrawerReviewConnected} from '../drawerReview/drawerReview';

import {popupButtonConstants, REVIEW_PROVIDERS_SHOWED_ONCE} from './constants';

import {RateUsContent} from './rateUsContent/rateUsContent';
import {RateUsContentRedesign} from './rateUsContentRedesign/rateUsContentRedesign';

type PropsType = {
    isRedesign?: boolean;
};

/**
 * Rate us component which open rating popup after rate us btn click
 */
export const RateUsSection: FC<PropsType> = ({isRedesign = false}) => {
    const [isButtonClicked, setIsButtonClicked] = useState(false);
    const [isDrawerOpen, setIsDrawerOpen] = useState(false);
    const {
        initAdditionalPopups,
        isPopupLoading,
        selectedPopup,
        setShowReviewPopups,
        showReviewPopups,
    } = useAdditionalPopups();

    const sendAnalytics = () => {
        sendMobileAnalyticsPerSession({
            event: TYP_RATE_US,
            label: `${selectedPopup.eventLabel} - CTA Clicked`,
        });
    };

    const showPopup = useCallback(() => {
        setIsDrawerOpen(true);
        setShowReviewPopups(true);
        initAdditionalPopups();
        setIsButtonClicked(true);
    }, [initAdditionalPopups, setShowReviewPopups]);

    useEffect(() => {
        let timer: ReturnType<typeof setTimeout>;
        if (Object.keys(popupButtonConstants).includes(selectedPopup?.id)) {
            timer = setTimeout(() => {
                showPopup();
            }, 2000);
        }
        return () => {
            clearTimeout(timer);
        };
    }, [selectedPopup?.id, showPopup]);

    if (!selectedPopup) return null;

    if (
        isButtonClicked &&
        !isPopupLoading &&
        REVIEW_PROVIDERS_SHOWED_ONCE.includes(selectedPopup.id)
    )
        return null;

    const getContent = () => {
        const sharedProps = {isPopupLoading, selectedPopup, sendAnalytics, showPopup};

        return (
            <>
                {isRedesign ? (
                    <RateUsContentRedesign {...sharedProps} />
                ) : (
                    <RateUsContent {...sharedProps} />
                )}
            </>
        );
    };

    return (
        <>
            {getContent()}
            {showReviewPopups && selectedPopup.id === REVIEWS_POPUPS.TRUST_PILOT && (
                <DrawerReviewConnected
                    isDrawerOpen={isDrawerOpen}
                    setIsDrawerOpen={setIsDrawerOpen}
                />
            )}
        </>
    );
};
